module.exports = __webpack_public_path__ + "img/7.8bb6cf38.webp";